import React from 'react'

import Spinner from '../spinner'

const Loader = () => (
  <div className="loader-wrapper">
    <div className="loader-content">
      <h1>Welcome to XO!</h1>
      <p>Loading promotion...</p>
      <Spinner />
    </div>
  </div>
)

export default Loader